var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input (input) type=\"color\">"}],
    template = twig({"id":"$resolved:85c187517379fe1ea230b237d211eba47fb9ee9ed75e2495f8d6572b537ffd1742c833a6b5447c059d58d94c431389f9c5362f5c04271831a55dadb0f1c9eeb7:magic-input-color.twig","data":[{"type":"raw","value":"<input (input) type=\"color\">"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;